import PropTypes from 'prop-types'
import React from 'react'
import { FormHelperText } from '@mui/material'
import InfoIcon from '@mui/icons-material/Info'

const ErrorValidationMessage = ({ showInfoIcon, error, className }) => {
  return (
    <FormHelperText
      error
      className={`${className} js-error flex flex-col md:flex-row`}
      sx={{ '&.MuiFormHelperText-root.Mui-error': { color: '#CF000B' } }}
    >
      {showInfoIcon && <InfoIcon className="mr-2 mb-2 md:mb-0" />}
      {error}
    </FormHelperText>
  )
}

export default ErrorValidationMessage

ErrorValidationMessage.propTypes = {
  className: PropTypes.string,
  error: PropTypes.string,
  showInfoIcon: PropTypes.bool
}
